module.exports = __webpack_public_path__ + "img/erasmus-logo.75abe450.svg";